// @ts-nocheck
import React, { Component } from 'react';
import axios from 'axios';

export const fetchApi = (url, fileId, accessToken) => {
  var response = axios.get(url + fileId, {
    headers: {
      'Conent-Type': 'application/json',
      Authorization: 'Bearer ' + accessToken,
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUB_KEY as string,
    },
    responseType: 'blob',
  });

  return response;
};

export const fetchApiAnonymous = (url, fileId) => {
  var response = axios.get(url + fileId, {
    headers: {
      'Conent-Type': 'application/json',
      "Ocp-Apim-Subscription-Key": process.env.REACT_APP_SUB_KEY as string,
    },
    responseType: 'blob',
  });

  return response;
};
